const SahIcon = props => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="21" cy="21" r="20.5" fill="white" stroke="#FB6E44" />
    <path
      d="M20.7143 8C23.0255 8 25.242 8.91811 26.8762 10.5524C28.5105 12.1866 29.4286 14.4031 29.4286 16.7143H12C12 14.4031 12.9181 12.1866 14.5524 10.5524C16.1866 8.91811 18.4031 8 20.7143 8"
      fill="#C9E3F7"
    />
    <path
      d="M20.7143 34.1428C18.4031 34.1428 16.1866 33.2247 14.5524 31.5905C12.9181 29.9562 12 27.7397 12 25.4285H29.4286C29.4286 27.7397 28.5105 29.9562 26.8762 31.5905C25.242 33.2247 23.0255 34.1428 20.7143 34.1428Z"
      fill="#0A0777"
    />
    <path
      d="M20.7143 25.4286C18.4031 25.4286 16.1866 24.5105 14.5524 22.8762C12.9181 21.242 12 19.0255 12 16.7143H20.7143V25.4286Z"
      fill="#FB6E44"
    />
    <path
      d="M20.7139 16.7143C23.025 16.7143 25.2416 17.6324 26.8758 19.2667C28.51 20.9009 29.4282 23.1174 29.4282 25.4286H20.7139V16.7143Z"
      fill="#FFCCEF"
    />
  </svg>
);

export default SahIcon;
